/**
 * Created by daniel on 11/04/17.
 */
import React, { Component } from 'react';
import Paper from 'material-ui/Paper'
import ContentFrameContainer from "./ContentFrameContainer";
import DropZoneFrameContainer from "./DropZoneFrameContainer";

const paperStyle = {
  //minHeight: 400,
  width:"90vw",
  maxWidth: "800px",
  marginLeft: 'auto',
  marginRight: 'auto',
  //paddingTop: "3vw",
};

class Canvas extends Component {
  render() {
    return (
    <div id="canvas-element" style={{width: "100%", padding: "20px 0"}}>
      <Paper style={paperStyle} zDepth={2}>
        {this.props.children}
      </Paper>
      <ContentFrameContainer/>
      <DropZoneFrameContainer/>
    </div>
    );
  }
}

export default Canvas;


// WEBPACK FOOTER //
// ./src/App/Editor/components/ui/Canvas.js